import CancellableHelper from "@/requests/CancellableHelper";

// Models

//#region Routes
export const URL_POST_ADD_CERT = "/KSEF/AddCert";
export const URL_GET_TEST_LOGIN = "/KSEF/TestLogin";
export const URL_GET_CHECK_CERT_EXISTS = "/KSEF/CheckCertExist/${Type}";
export const URL_POST_REMOVE_CERT = "/KSEF/RemoveCert/${Type}";
export const URL_POST_SAVE_OFFICE_CONFIGURATION = "/KSEF/SaveOfficeConfiguration/${System}";
export const URL_GET_OFFICE_CONFIGURATION = "/KSEF/OfficeConfiguration";

const _addKsefCert = new CancellableHelper<null>(URL_POST_ADD_CERT, null, true);
export const addKsefCert = async (param: {
  certString: string;
  encryptedPrivateKey: string;
  password: string;
  type: string;
}): Promise<null> => {
  return await _addKsefCert.post({}, param);
};

const _testKsefLogin = new CancellableHelper<null>(URL_GET_TEST_LOGIN, null, true);
export const testKsefLogin = async (): Promise<null> => {
  return await _testKsefLogin.get();
};

const _checkKsefCertificateExists = new CancellableHelper<boolean>(URL_GET_CHECK_CERT_EXISTS, "boolean");
export const checkKsefCertificateExists = async (type: string): Promise<boolean> => {
  return await _checkKsefCertificateExists.get({ Type: type });
};

const _removeKsefCert = new CancellableHelper<null>(URL_POST_REMOVE_CERT, null, true);
export const removeKsefCert = async (type: string): Promise<null> => {
  return await _removeKsefCert.post({ Type: type }, null);
};

const _saveOfficeConfiguration = new CancellableHelper<null>(URL_POST_SAVE_OFFICE_CONFIGURATION, null, true);
export const saveOfficeConfiguration = async (system: "optima" | "symfonia"): Promise<null> => {
  return await _saveOfficeConfiguration.post({ System: system }, null);
};

const _getOfficeConfiguration = new CancellableHelper<"optima" | "symfonia">(URL_GET_OFFICE_CONFIGURATION, "string");
export const getOfficeConfiguration = async (): Promise<"optima" | "symfonia"> => {
  return await _getOfficeConfiguration.get();
};
